import { useId } from "react";

/**
 * The house ornament: an eight-pointed star lattice in 1px hairlines — the geometry of zellige and of
 * Saharan architecture, drawn as outline only. It stands in for photography until real images exist
 * and frames empty states. Strokes do not scale (vector-effect) so the line stays exactly 1px.
 */
export function Pattern({ className = "", size = 80 }: { className?: string; size?: number }) {
  const id = useId();
  const R = 32, h = R * Math.SQRT1_2, c = 40;
  const star = `M${c} ${c - R}L${c + R} ${c}L${c} ${c + R}L${c - R} ${c}Z M${c - h} ${c - h}H${c + h}V${c + h}H${c - h}Z`;
  const knot = (x: number, y: number) => `M${x} ${y - 8}L${x + 8} ${y}L${x} ${y + 8}L${x - 8} ${y}Z`;
  return (
    <svg className={`pattern ${className}`} aria-hidden="true" focusable="false">
      <defs>
        <pattern id={id} width={size} height={size} patternUnits="userSpaceOnUse" viewBox="0 0 80 80">
          <path d={star} fill="none" stroke="currentColor" strokeWidth="1" vectorEffect="non-scaling-stroke" />
          <path d={[knot(0, 0), knot(80, 0), knot(0, 80), knot(80, 80)].join(" ")} fill="none" stroke="currentColor" strokeWidth="1" vectorEffect="non-scaling-stroke" />
          <circle cx={c} cy={c} r="3" fill="none" stroke="currentColor" strokeWidth="1" vectorEffect="non-scaling-stroke" />
        </pattern>
      </defs>
      <rect width="100%" height="100%" fill={`url(#${id})`} />
    </svg>
  );
}
